import React, { useEffect, useState, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux"

import { DropDownField, TextInputField, AutoCompleteField } from "../../../helpers"
import Loading from '../../../common/Loading'
import Button from "../../../helpers/Button"
import { Menu } from 'primereact/menu'
import moment from "moment"
import { utils, write } from "xlsx"
import Papa from "papaparse"
import _ from 'lodash'

import { fetchBuyerInvoice, updateBuyerInvoiceData, updateSearchOptions, updateSearchParams, setSearchConfig, setTotalBasicAmount } from "../../../services/redux/reducers/adminAccountBuyer/adminAccountsBuyer"
import { fetchStates, fetchCompanySupplyType } from '../../../services/redux/reducers/commonThunk'
import { raiseToast } from '../../../services/redux/reducers/toast/toast'

import { searchBuyerInvoice } from '../../../services/api/adminAccountBuyer';
import { getBuyerInvoiceItems } from '../../../services/api/buyerInvoiceItem'
import { generateReplacedProducts, getAddFilterOptions, getAutoSearchSuggestions, getDateRange, getDateString, getFullName, getMatchedRegexPattern, normalizeLabel, round, useFuzzSearch } from '../../../utils'
import { getMaterialItemsDataByBuyerReqItemIds } from '../../../services/api/buyerReqItem'
import { getCompanyBillAddrs } from '../../../services/api/companyBillAddr'
import { getAdjustmentNoteItems } from '../../../services/api/adjustmentNoteItems'
import { getDocItemReplacementLogAndMapByDocIds } from '../../../services/api/docItemReplacementLog'
import DateFilter from "../../../common/DateFilter";
import { DATE_FORMAT } from '../../../constants'

const buyerInvoiceSearchConfig = [
    {
        srNO: 1,
        static: true,
        type: "SELECT",
        name: "dataType",
        label: "Data type",
        options: [
            { label: 'Buyer Invoice', value: 'buyerInvoice' },
            { label: 'Accounts Data', value: 'accountInvoice' },
            // { label: 'Address Data', value: 'addressInvoice' },
            { label: 'Credit Notes Sales Data', value: 'creditNotesData' },
            { label: 'Products Data', value: 'productsInvoice' },
            { label: 'Sales Data', value: 'salesInvoice' },
        ]
    },
    {   srNO: 2,
        static: true,
        type: "SEARCH_TEXT",
        name: "searchText",
        label: "Search Text",
    },
    {
        srNO: 3,
        static: true,
        type: "DATE",
        name: "dateType",
        label: "Date",
        options: [
            { label: 'Created Date', value: 'createdAt' }
        ]
    },
    {
        srNO: 4,
        static: false,
        type: "SELECT",
        name: "branchId",
        label: "Branch",
    },
    {
        srNO: 5,
        static: false,
        type: "SELECT",
        name: "pmStateId",
        label: "PM State"
    },
    {
        srNO: 6,
        static: false,
        type: "SELECT",
        name: "isClientGRNDone",
        label: "GRN Done",
        options: [
            { label: 'Yes', value: true },
            { label: 'No', value: false }
        ]
    },
    {
        srNO: 7,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "userName",
        label:"User Name",
    },
    {
        srNO: 8,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "companyName",
        label:"Company Name",
        priority: 2
    },
    {
        srNO: 9,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "AUTO_COMPLETE",
        name: "kamName",
        label:"Kam Name",
        priority: 1
    },
    {
        srNO: 10,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "gstin",
        label:"GSTIN",
    },
    {
        srNO: 11,
        static: false,
        removable: true,
        isSearchByOption: true,
        type: "TEXT",
        name: "docNo",
        label:"Doc No",
    },
    {
        srNO: 12,
        static: false,
        removable: true,
        type: "TEXT",
        name: "buyerBranch",
        label:"Buyer branch"
    }
]


const Search = (props) => {
    const { handleTableColumn, setDataType, setAdjustmentNoteItems } = props

    const isPageLoading = useSelector(state => state.adminAccountsBuyerSlice.loading)

    const [isLoading, setIsLoading] = useState(false)
    const [suggestions, setSuggestions] = useState([])

    const paginationParams = useSelector(state => state.adminAccountsBuyerSlice.paginationParams)
    const searchParams = useSelector(state => state.adminAccountsBuyerSlice.searchParams)
    const searchOptions = useSelector(state => state.adminAccountsBuyerSlice.searchOptions)
    const states = useSelector(state => state.common.states)
    const userDetails = useSelector((state) => state.userDetails)
    const companySupplyTypes = useSelector((state) => state.common.companySupplyType) 
    const companyBranches = userDetails?.PMCompanyDetails?.companyBranches

    const filterMenu = useRef(null)
    const downloadMenu = useRef(null)
    const searchTextRef = useRef(null)
    
    const searchConfig = buyerInvoiceSearchConfig

    const dispatch = useDispatch()

    let pmCompanyUsers = userDetails.PMCompanyDetails.companyUsers ? userDetails.PMCompanyDetails.companyUsers : []

    pmCompanyUsers = pmCompanyUsers.map(eachPerson => {
        const name = getFullName(eachPerson.firstName,eachPerson.lastName)
        return {...eachPerson, displayName: name}
    })


    useEffect(() => {
        dispatch(setSearchConfig(buyerInvoiceSearchConfig))
        dispatch(fetchStates())
        dispatch(fetchCompanySupplyType())
    }, [])

    useEffect(()=> {
        if(searchOptions.length === 0){
            let filteredSearchOptions = searchConfig.filter(eachOption => eachOption.static)
            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [])

    useEffect(() => {
        if(searchOptions.length > 0){
            let filteredSearchOptions = searchOptions
            filteredSearchOptions = filteredSearchOptions?.map(eachSearchOption => {
                let updatedSearchOptions = JSON.parse(JSON.stringify(eachSearchOption))
                if (eachSearchOption?.name === "searchBy" && searchParams?.dataType !== "creditNotesData"){
                    let options = [
                        { label: 'Total Price', value: 'totalPrice' },
                        { label: 'Total Price Before Tax', value: 'totalPriceBeforeTax' },
                    ]
                    updatedSearchOptions = {...updatedSearchOptions, options: [...updatedSearchOptions.options , ...options]}
                }
                return updatedSearchOptions
            })

            dispatch(updateSearchOptions(filteredSearchOptions))
        }
    }, [searchParams])

    useEffect(() => {
        if (searchTextRef.current) {
            searchTextRef.current.focus()
        }
    }, [searchParams.searchBy])

    useEffect(() => {
        if (['kamName'].includes(searchParams.searchBy)) {
            autoCompleteSearch(searchParams.searchBy, searchParams.searchText)
        }
    }, [searchParams.searchBy])

    const kamFuzzSearch = useFuzzSearch(pmCompanyUsers, "displayName")

    const addFilterOption = (srNO) => {
        let relatedConfig = searchConfig.find(eachConfig => eachConfig.srNO === srNO)
        if(relatedConfig?.name === "branchId"){
            const updatedCompanyBranches = companyBranches?.map(eachCompanyBranch => ({...eachCompanyBranch, label: eachCompanyBranch.branchName, value: eachCompanyBranch.branchId}))
            relatedConfig = {...relatedConfig, options: updatedCompanyBranches}
        }
        if(relatedConfig?.name === "pmStateId"){
            const pmCompanyBillAddrIds = userDetails.PMCompanyDetails.companyBranches.map(eachCompanyBranch => eachCompanyBranch.primaryBillAddrId)
            const pmCompanyBillAddrs = userDetails.PMCompanyDetails.companyBillAddrs.filter(eachCompanyBillAddr => pmCompanyBillAddrIds.includes(eachCompanyBillAddr.billAddrId))

            const allStateIds = _.map(pmCompanyBillAddrs, 'stateId')
            const filteredStates = _.filter(states, (state) => allStateIds.includes(state.stateId))

            const updatedStates = filteredStates?.map(eachState => ({...eachState, label: eachState.stateName, value: eachState.stateId}))
            relatedConfig = {...relatedConfig, options: updatedStates}
        }
        dispatch(updateSearchOptions([...searchOptions, {...relatedConfig}]))
    }

    const removeFilterOption = (srNO) => {
        const relatedSearchOption = searchOptions.find(eachOption => eachOption.srNO === srNO)
        const updatedSearchParams = {...searchParams}

        if(relatedSearchOption.type === "SEARCH_BY"){
            updatedSearchParams.searchText = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "DATE"){
            updatedSearchParams.fromDate = null
            updatedSearchParams.toDate = null
            updatedSearchParams.range = ""
            console.log("updateSearchParams", updatedSearchParams)
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if(relatedSearchOption.type === "SELECT"){
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "MULTISELECT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "TEXT") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }
        if (relatedSearchOption.type === "AUTO_COMPLETE") {
            updatedSearchParams[relatedSearchOption.name] = ""
            dispatch(updateSearchParams(updatedSearchParams))
        }

        const filteredSearchOptions = searchOptions.filter(eachOption => eachOption.srNO !== srNO)
        dispatch(updateSearchOptions([...filteredSearchOptions]))
    }

    const handleSearchOnChange = (event) => {
        let eventValue = event.target.value

        if(eventValue && (eventValue.userId || eventValue.companyId)){
            eventValue = eventValue.displayName
        }

        if (event.target.name === "dataType"){
            dispatch(updateBuyerInvoiceData())
            dispatch(setTotalBasicAmount(0))
            setDataType(event.target.value)
            setAdjustmentNoteItems([])
        }
        const updatedSearchParams = {...searchParams, [event.target.name]: eventValue}

        if(event.target.name === "searchText"){
            const availableOptions = [...buyerInvoiceSearchConfig]
            const matchText = eventValue.split(";")[0]
            const matchedPattern = getMatchedRegexPattern(matchText, availableOptions, searchParams.searchBy)
            updatedSearchParams.searchBy = matchedPattern
        }

        if (eventValue instanceof Date) {
            if(new Date(searchParams[event.target.name])?.getTime() != eventValue.getTime()){
                updatedSearchParams.range = null
            }

            if (event.target.name === "toDate") {
                eventValue.setHours(23, 59, 0, 0)
            }
            if (event.target.name === "fromDate") {
                eventValue.setHours(0, 0, 0, 0)
            }
            eventValue = eventValue.toISOString()

            updatedSearchParams[event.target.name] = eventValue
        }
        
        dispatch(updateSearchParams(updatedSearchParams))

        handleTableColumn(updatedSearchParams)
    }

    const handleDateRangeChange = (range) => {
        const { fromDate, toDate } = getDateRange(range)
        getDateRange(range)
        dispatch(updateSearchParams({ ...searchParams, range, fromDate, toDate }))
    }

    const autoCompleteSearch = (searchType, query) => {        
        const suggestions = getAutoSearchSuggestions({
            searchType,
            query,
            pmCompanyUsers,
            kamFuzzSearch,
        })
        
        setSuggestions(suggestions)
    }

    const addFilterOptions = getAddFilterOptions(searchConfig, searchOptions, searchParams, addFilterOption)

    const handleSearch = () => {
        if(!searchParams.searchBy){
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please select search by', life: 3000 }))
        }
        if(!searchParams.searchText && searchParams.searchBy != 'all'){
            return dispatch(raiseToast({ severity: 'warn', detail: 'Please enter search text', life: 3000 }))
        }

        if(searchParams.dateType && (!searchParams.fromDate || !searchParams.toDate)){
            return dispatch(raiseToast({severity:'error', detail: "Please select from date and to date" , life: 3000}))
        }

        let from_date = searchParams.fromDate
        let to_date = searchParams.toDate
        if (searchParams.fromDate) {
            from_date = moment(searchParams.fromDate, "DD.MM.YYYY").toDate()
        }
        if (searchParams.toDate) {
            to_date = moment(searchParams.toDate, "DD.MM.YYYY").toDate()
        }
        const date_difference =  moment(new Date(to_date)).diff(moment(new Date(from_date)), 'days')
        
        if(date_difference > 31){
            return dispatch(raiseToast({severity:'error', detail: "Please select Date range within 1 month" , life: 3000}))
        }


        let errorFound = false

        if (searchParams.searchText === "" && searchParams.searchBy !== "all") {
            dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: "Please enter search text" }))
            errorFound = true
        } 
        else if (searchParams.searchText && searchParams.searchBy !== "all"){
            const relatedSearchOption = searchConfig.find(eachOption => eachOption.name === searchParams.searchBy)
            if(relatedSearchOption.isValid && !relatedSearchOption.isValid(searchParams.searchText.split(";")[0])){
                dispatch(raiseToast({ severity: 'error', summary: normalizeLabel(searchParams.searchBy), detail: `Please enter valid ${normalizeLabel(searchParams.searchBy).toLowerCase()}` }))
                errorFound = true
            }
        }
        
        searchOptions.map(eachOption => { 
            if (["TEXT", "SELECT", "AUTO_COMPLETE"].includes(eachOption.type)) {
                if (!searchParams[eachOption.name] && searchParams[eachOption.name] !== false) {
                    const errorMsgText = normalizeLabel(eachOption.label)
    
                    dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter ${errorMsgText.toLowerCase()}` }))
                    errorFound = true
                } else {
                    if(eachOption.isValid && !eachOption.isValid(searchParams[eachOption.name].split(";")[0])){
                        const errorMsgText = normalizeLabel(eachOption.label)
                        dispatch(raiseToast({ severity: 'error', summary: errorMsgText, detail: `Please enter valid ${errorMsgText.toLowerCase()}` }))
                        errorFound = true
                    }
                }
            } 
        })

        const updatedSearchParams = {...searchParams}

        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }
        console.log("searchParams", searchParams)
        if(!errorFound){
            dispatch(fetchBuyerInvoice({...paginationParams, ...updatedSearchParams, pageNo: 0 }))
        }

        props.setSelectedBuyerInvoiceIds([])
    }

    const downloadFormatOptions = [
        {
            label: "XLSX",
            command: () => downloadDataHandler("XLSX")
        },
        {
            label: "CSV",
            command: () => downloadDataHandler("CSV")
        }
    ]

    const downloadDataHandler = async (dataFormat) => {
        const { dataType } = searchParams

        console.log("DataTye", dataType)
        
        if(dataType == "accountInvoice"){
            downloadAccountsData(dataFormat)
        }
        else if (dataType === "buyerInvoice"){
            downloadData(dataFormat)
        }
        else if(dataType == "addressInvoice"){
            downloadAddressData(dataFormat)
        }
        else if(dataType == "productsInvoice"){
            downloadProductsData(dataFormat)
        }
        else if(dataType == "salesInvoice"){
            downloadSalesData(dataFormat)
        }
        else if(dataType === "creditNotesData"){
            downloadCreditNotesData(dataFormat)
        }
    }

    const downloadSalesData = async (dataFormat) => {
        setIsLoading(true)

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        const response = await getBuyerInvoiceItems({ ...updatedSearchParams, paginator: false, joinRequired: true })
        console.log("getBuyerInvoiceItems response", response, searchParams)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            let invoices = response.data
            let buyerReqItemsIds = invoices?.map(eachInvoice => eachInvoice?.buyerReqItemId).filter(eachBuyerReqItemId => eachBuyerReqItemId)
            let materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({buyerReqItemsIds: buyerReqItemsIds})
            if (materialDetailsRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: materialDetailsRes.data.error, life: 3000 }))
            }
            let materialDetails = materialDetailsRes?.data

            let pmBillAddrsIds = invoices?.map(eachInvoice => eachInvoice["buyerInvoice.pmBillAddrId"])
            let relatedBillAddrsRes = await getCompanyBillAddrs({billAddrIds: pmBillAddrsIds, paginator: false})
            if (relatedBillAddrsRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: relatedBillAddrsRes.data.error, life: 3000 }))
            }
            let pmBillAddresses = relatedBillAddrsRes?.data?.data

            const buyerInvoiceIds = response.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem.buyerInvoiceId)
            const docReplacementItems = await getDocItemReplacementLogAndMapByDocIds({docIds: buyerInvoiceIds})

            invoices = generateReplacedProducts(response.data, docReplacementItems.data)

            console.log("invoices", invoices)

            const salesData = []

            let totalAmount = 0
            let totalAmountBeforeTax = 0
            let totalCGST = 0
            let totalSGST = 0
            let totalIGST = 0

            let salesVoucher = ''


            for (let i = 0; i < invoices.length; i++) {

                let logisticAddedFlag = false
                let logisticsIGSTLedger = ''
                let logisticsCGSTLedger = ''
                let logisticsSGSTLedger = ''
                let logisticsCGSTRate = 0
                let logisticsSGSTRate = 0
                let logisticsIGSTRate = 0
                let logisticsAmount = 0
                
                let logisticsCGSTAmount = 0
                let logisticsIGSTAmount = 0

                let logisticsTaxAmount = round(invoices[i]["buyerInvoice.logisticsWithTax"] - invoices[i]["buyerInvoice.logisticsBeforeTax"], 2)

                let counter = i + 1

                let relatedState = states?.find(eachState => eachState?.stateId === parseInt(invoices[i]['buyerInvoice.billingAddress.gstinCode']?.slice(0,2)))

                let basicPrice = invoices[i].itemAmountWithTax - invoices[i].itemAmountBeforeTax

                let cgstAmount = 0
                let sgstAmount = 0
                let CSGSTRate = 0
                let CGSTLedger = ''
                let SGSTLedger = ''

                let sellerState = ""
                let procmartState = ""

                const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])

                let isIGST = invoices[i]["buyerInvoice.billingAddress.stateId"] === relatedPMBillAddress?.stateId ? false : true

                if(invoices[i]["buyerInvoice.billingAddress.gstinCode"] && !["URP", "URD"].includes(invoices[i]["buyerInvoice.billingAddress.gstinCode"]) && relatedPMBillAddress.gstinCode && !["URP", "URD"].includes(relatedPMBillAddress.gstinCode)){
                    isIGST = parseInt(invoices[i]["buyerInvoice.billingAddress.gstinCode"].slice(0, 2)) !== parseInt(relatedPMBillAddress.gstinCode.slice(0, 2))
                }

                if([3, 4].includes(invoices[i]["buyerInvoice.supplyTypeId"])){
                    isIGST = true
                }

                let GSTType = isIGST ? "I" : "CS"

                if(invoices[i]["buyerInvoice.logisticsGSTRate"]){
                    if(GSTType === "I"){
                        logisticsIGSTRate = invoices[i]["buyerInvoice.logisticsGSTRate"]
                    } else {
                        logisticsCGSTRate = invoices[i]["buyerInvoice.logisticsGSTRate"] / 2
                    }
                }

                if (GSTType == "CS") { //if (invoices[i]["buyerInvoice.GSTType"] == "CS") {
                    cgstAmount = basicPrice / 2
                    sgstAmount = basicPrice / 2
                    CSGSTRate = invoices[i].GSTRate / 2
                }

                let igstAmount = 0
                let IGSTRate = 0
                let IGSTLedger = ''
                if (GSTType == "I") {
                    igstAmount = basicPrice
                    IGSTRate = invoices[i].GSTRate
                }

                const stateLedgerCode = {
                    "TAMIL NADU" : "TN",
                    "UTTARAKHAND" : "UK",
                    "HARYANA" : "HR",
                    "GOA" : "GOA",
                    "WEST BENGAL" : "WB",
                }

                const voucherTypeMapperObj = {
                    "UTTARAKHAND": "Sales UK",
                    "HARYANA": "Sales HR",
                    "DELHI": "Sales DEL",
                    "UTTAR PRADESH": "Sales UP",
                    "WEST BENGAL": "Sales WB",
                    "ODISHA": "Sales OD",
                    "MADHYA PRADESH": "Sales MP",
                    "GUJARAT": "Sales GJ",
                    "MAHARASHTRA": "Sales",
                    "KARNATAKA": "Sales KA",
                    "GOA": "Sales GA",
                    "TAMIL NADU": "Sales TN",
                    "TELANGANA": "Sales TEL",
                    "ANDHRA PRADESH": "Sales AP",
                    "CHATTISGARH": "Sales CG"
                }

                const costCenterMapperObj = {
                    "UTTARAKHAND": "Uttarakhand",
                    "HARYANA": "Haryana",
                    "DELHI": "Delhi",
                    "UTTAR PRADESH": "Uttar Pradesh",
                    "WEST BENGAL": "Kolkata",
                    "ODISHA": "Odisha",
                    "MADHYA PRADESH": "Madhya Pradesh",
                    "GUJARAT": "Gujarat",
                    "MAHARASHTRA": "Pune",
                    "KARNATAKA": "Karnataka",
                    "GOA": "GOA",
                    "TAMIL NADU": "Chennai",
                    "TELANGANA": "Telangana",
                    "ANDHRA PRADESH": "Andhra Pradesh",
                    "CHATTISGARH": "Chattisgarh",
                    "KERALA": "Kerala"
                }

                if (logisticsIGSTRate && logisticAddedFlag == false) {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = stateLedgerCode[relatedPMState?.stateName?.toUpperCase()]  //relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    if(!relatedStateCode){
                        relatedStateCode = relatedPMState?.stateName.slice(0, 1)
                    }

                    logisticsIGSTLedger = relatedStateCode + ' IGST On Output @ ' + logisticsIGSTRate + "%"
                    logisticsIGSTAmount = logisticsTaxAmount
                    logisticAddedFlag = true
                }
                else if (logisticsCGSTRate && logisticAddedFlag == false) {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = stateLedgerCode[relatedPMState?.stateName?.toUpperCase()]  //relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    if(!relatedStateCode){
                        relatedStateCode = relatedPMState?.stateName.slice(0, 1)
                    }

                    logisticsCGSTLedger = relatedStateCode + ' CGST On Output @ ' + logisticsCGSTRate + "%"
                    logisticsSGSTLedger = relatedStateCode + ' SGST On Output @ ' + logisticsCGSTRate + "%"
                    logisticsCGSTAmount = round(logisticsTaxAmount / 2, 2)
                    logisticAddedFlag = true
                }
                else {
                    if (invoices[i].logisticsCharge) {
                        logisticAddedFlag = true
                    }
                }

                if (invoices[i].GSTRate && GSTType === "I") {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = stateLedgerCode[relatedPMState?.stateName?.toUpperCase()]  //relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    if(!relatedStateCode){
                        relatedStateCode = relatedPMState?.stateName.slice(0, 1)
                    }
                    IGSTLedger = relatedStateCode + " " + "IGST On Output @" + " " + invoices[i].GSTRate + "%"
                }
                else {
                    IGSTLedger = ''
                }

                if (invoices[i].GSTRate && GSTType === "CS") {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = stateLedgerCode[relatedPMState?.stateName?.toUpperCase()]  //relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    if(!relatedStateCode){
                        relatedStateCode = relatedPMState?.stateName.slice(0, 1)
                    }
                    SGSTLedger = relatedStateCode + " " + "SGST On Output @" + " " + (invoices[i].GSTRate/2) + "%"
                }
                else {
                    SGSTLedger = ''
                }

                if (invoices[i].GSTRate && GSTType === "CS") {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = stateLedgerCode[relatedPMState?.stateName?.toUpperCase()]  //relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    if(!relatedStateCode){
                        relatedStateCode = relatedPMState?.stateName.slice(0, 1)
                    }
                    CGSTLedger = relatedStateCode + " " + "CGST On Output @" + " " + (invoices[i].GSTRate/2) + "%"
                }
                else {
                    CGSTLedger = ''
                }

                let purchaseLedger = ''
                if(!invoices[i].GSTRate){
                    console.log("enetr")
                    if (invoices[i]["buyerInvoice.billingAddress.gstinCode"]) {
                        let relatedSellerState = states.find(eachState => eachState.stateId === parseInt(invoices[i]["buyerInvoice.billingAddress.gstinCode"].slice(0,2)))
                        sellerState = relatedSellerState?.stateName
                    }
                    if(["URD", "URP"].includes(invoices[i]["buyerInvoice.billingAddress.gstinCode"])){
                        let relatedSellerState = states.find(eachState => eachState.stateId === invoices[i]["buyerInvoice.billingAddress.stateId"])
                        sellerState = relatedSellerState?.stateName
                    }
                    if (invoices[i]["buyerInvoice.pmBillAddrId"]) {
                        const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                        let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                        if(relatedPMState?.stateId){
                            procmartState = relatedPMState?.stateName
                        }
                    }
                    
                    if(sellerState.toUpperCase() != procmartState.toUpperCase()){
                        purchaseLedger = "IGST Sales @ 0 %"
                    }
                    else{
                        if (invoices[i].HSNCode.toString().startsWith('99')) {
                            console.log("if trigger", purchaseLedger, i)
                            purchaseLedger = "Basic Sales @" + " " + (invoices[i].GSTRate) + "%" 
                            if(invoices[i].GSTRate){
                                purchaseLedger += "_Services"
                            }
                        }
                        else {
                            purchaseLedger = "Basic Sales @" + " " + (invoices[i].GSTRate) + "%" 
                            if(invoices[i].GSTRate){
                                purchaseLedger += "_Goods"
                            }
                        }
                    }
                }else{
                    if (invoices[i].GSTRate && GSTType === "I") {
                        if (invoices[i].HSNCode.toString().startsWith('99')) {
                            purchaseLedger = "IGST Sales @" + " " + invoices[i].GSTRate + "%"
                            if(invoices[i].GSTRate){
                                purchaseLedger += "_Services"
                            }
                        }
                        else {
                            purchaseLedger = "IGST Sales @" + " " + invoices[i].GSTRate + "%"
                            if(invoices[i].GSTRate){
                                purchaseLedger += "_Goods"
                            }
                        }
                    }
                    else {
                        if (invoices[i].HSNCode.toString().startsWith('99')) {
                            purchaseLedger = "Basic Sales @" + " " + (invoices[i].GSTRate) + "%"
                            if(invoices[i].GSTRate){
                                purchaseLedger += "_Services"
                            }
                        }
                        else {
                            purchaseLedger = "Basic Sales @" + " " + (invoices[i].GSTRate) + "%"
                            if(invoices[i].GSTRate){
                                purchaseLedger += "_Goods"
                            }
                        }
                    }
                }

                if([4].includes(invoices[i]["buyerInvoice.supplyTypeId"])){
                    if (invoices[i].HSNCode.toString().startsWith('99')) {
                        purchaseLedger = "IGST Sales @" + " " + invoices[i].GSTRate + "%" 
                        if(invoices[i].GSTRate){
                            purchaseLedger += "_Services"
                        }
                    }
                    else {
                        purchaseLedger = "IGST Sales @" + " " + invoices[i].GSTRate + "%"
                        if(invoices[i].GSTRate){
                            purchaseLedger += "_Goods"
                        }
                    }
                }

                if (invoices[i]["buyerInvoice.pmBillAddrId"]) {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === invoices[i]["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    procmartState = relatedPMState?.stateName
                    if(relatedPMState?.stateId){
                        /*if(relatedPMState?.stateName.toUpperCase() === "MAHARASHTRA"){
                            salesVoucher = "Sales"
                        }
                        else if(relatedPMState?.stateName.toUpperCase() === "TELANGANA"){
                            salesVoucher = "Sales TEL"
                        }
                        else{
                            if(relatedPMState?.stateName.toUpperCase() === "DELHI" || relatedPMState?.stateName.toUpperCase() === "UTTAR PRADESH"){
                                salesVoucher = "Sales " + relatedPMState?.stateCode
                            }else{
                                salesVoucher = "Sales " + relatedPMState?.stateCode
                            }
                        }*/
                        salesVoucher = voucherTypeMapperObj[relatedPMState?.stateName.toUpperCase()]

                        if(!salesVoucher){
                            salesVoucher = "Sales " + relatedPMState?.stateCode
                        }
                    }
                }

                let costCenter = costCenterMapperObj[procmartState.toUpperCase()]
                if(!costCenter){
                    costCenter = procmartState
                }

                if(procmartState){
                    if(procmartState.toUpperCase() === "MAHARASHTRA"){
                        procmartState = "Pune"
                    } else if(procmartState?.toUpperCase() === "TAMIL NADU"){
                        procmartState = "Chennai"
                    }
                }

                const date = moment(invoices[i]["buyerInvoice.createdAt"]).format(DATE_FORMAT)

                totalCGST = parseFloat(parseFloat(cgstAmount) + parseFloat(totalCGST)).toFixed(2)

                totalSGST = parseFloat(parseFloat(sgstAmount) + parseFloat(totalSGST)).toFixed(2)

                totalIGST = parseFloat(parseFloat(igstAmount) + parseFloat(totalIGST)).toFixed(2)
                totalAmountBeforeTax = parseFloat(parseFloat(invoices[i]?.itemAmountBeforeTax) + parseFloat(totalAmountBeforeTax)).toFixed(2)
                totalAmount = parseFloat(parseFloat(invoices[i]?.itemAmountWithTax) + parseFloat(totalAmount)).toFixed(2)

                const buyerPONumbers = invoices[i]["buyerInvoice.buyerPONumbers"]?.length ?  invoices[i]["buyerInvoice.buyerPONumbers"]?.join(",") : ""
                
                let relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === invoices[i]?.materialId)
                let productName = (invoices[i].productName ? invoices[i].productName : relatedMaterial?.productName) + `: ${invoices[i]?.HSNCode}`

                let isCancelled = invoices[i]["buyerInvoice.statusId"] === 6 ? true : false
                let docNo = isCancelled ? `Cancelled - ${invoices[i].docNo}` : invoices[i].docNo

                const downloadObj = {
                    //'Sr. No.': counter,
                    'UNIQUE ID': docNo,
                    'BASE-VCH-TYPE': 'Sales',
                    'VCH-TYPE': salesVoucher,
                    'VCH-NO': docNo,
                    'VCH-DATE': date,
                    'REF NO': docNo,
                    'REF-DATE': date,
                    'PARTY': invoices[i]['buyerInvoice.billingAddress.ledgerName'] ? invoices[i]['buyerInvoice.billingAddress.ledgerName'] : invoices[i]['buyerInvoice.company.companyName'],
                    'GSTIN': invoices[i]['buyerInvoice.billingAddress.gstinCode'],
                    'State': relatedState?.stateName,
                    'Term Of Delivery': 'COD',
                    'Product Name': productName,
                    'HSN': invoices[i]?.HSNCode,
                    'Client ERP Code': invoices[i].companyERPCode,
                    'Unit': invoices[i].UOM ? invoices[i].UOM : relatedMaterial?.UOM,
                    'Quantity': invoices[i]?.qty,
                    'Rate':invoices[i]?.unitPrice,
                    'Amount': invoices[i]?.itemAmountBeforeTax,
                    'Other Charges Ledger': '',
                    'Other Charges Amount': '',
                    'Trade Discount': '',
                    'IGST Ledger': IGSTLedger,
                    'IGST %': IGSTRate,
                    'IGST Amount': igstAmount,
                    'CGST Ledger': CGSTLedger,
                    'CGST %': CSGSTRate,
                    'CGST Amount': cgstAmount,
                    'SGST Ledger': SGSTLedger,
                    'SGST %': CSGSTRate,
                    'SGST Amount': sgstAmount,
                    'Purchase Ledger': purchaseLedger,
                    'Narration': buyerPONumbers,
                    'Auto Round Off': 'Yes',
                    'Cost Center': costCenter
                }

                salesData.push(downloadObj)

                let logisticsFlag = false
                if(invoices[i]["buyerInvoice.logisticsWithTax"]){
                    logisticsFlag = true
                    let isLogisticsAdded = salesData.find(eachRow => eachRow["Product Name"] === "Transportation Cost" && eachRow["UNIQUE ID"] === docNo)
                    if(isLogisticsAdded){
                        logisticsFlag = false
                    }
                }

                if (logisticsFlag) {
                    salesData.push({
                        'UNIQUE ID': docNo,
                        'BASE-VCH-TYPE': 'Sales',
                        'VCH-TYPE': salesVoucher,
                        'VCH-NO': docNo,
                        'VCH-DATE': date,
                        'REF NO': docNo,
                        'REF-DATE': date,
                        'PARTY': invoices[i]['buyerInvoice.billingAddress.ledgerName'] ? invoices[i]['buyerInvoice.billingAddress.ledgerName'] : invoices[i]['buyerInvoice.company.companyName'],
                        'GSTIN': invoices[i]['buyerInvoice.billingAddress.gstinCode'],
                        'State': relatedState?.stateName,
                        'Term of Delivery': 'COD',
                        'Product Name': 'Transportation Cost',
                        'HSN': invoices[i]["buyerInvoice.logisticsHSNCode"],
                        'Unit': '',
                        'Quantity': '',
                        'Rate': invoices[i]["buyerInvoice.logisticsBeforeTax"],
                        'Amount': '',
                        'Other Charges Ledger': '',
                        'Other Charges Amount': '',
                        'Trade Discount': '',
                        'IGST Ledger': logisticsIGSTLedger,
                        'IGST %': logisticsIGSTRate,
                        'IGST Amount': logisticsIGSTAmount,
                        'CGST Ledger': logisticsCGSTLedger,
                        'CGST %': logisticsCGSTRate,
                        'CGST Amount': logisticsCGSTAmount,
                        'SGST Ledger': logisticsSGSTLedger,
                        'SGST %': logisticsCGSTRate,
                        'SGST Amount': logisticsCGSTAmount,
                        'Purchase Ledger': purchaseLedger,
                        'Narration': buyerPONumbers,
                        'Auto Round Off': 'Yes',
                        'Cost Center': costCenter,
                    })
                }
            }

            /*
            salesData.push({
                'Buyer Basic Price': totalAmountBeforeTax,
                'CGST Amount': parseFloat(totalCGST).toFixed(2),
                'SGST Amount': parseFloat(totalSGST).toFixed(2),
                'IGST Amount': parseFloat(totalIGST).toFixed(2),
                'Total Price': parseFloat(totalAmount).toFixed(2),
            })
            */

            if (dataFormat === "CSV") {
                let csv = Papa.unparse(salesData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "sales.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(salesData)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'sales.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const downloadCreditNotesData = async (dataFormat) => {
        setIsLoading(true)

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        const response = await getAdjustmentNoteItems({ ...updatedSearchParams, statusIds: [1, 6], paginator: false, joinRequired: true, docNoRequired: true, adjustmentTypeIds: [1, 2] })
        console.log("response", response, searchParams)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            const adjustmentNoteItems = response.data.data
            const buyerInvoiceItemIds = adjustmentNoteItems?.map(eachAdjustmentNoteItem => eachAdjustmentNoteItem?.buyerInvoiceItemId)
            const buyerInvoiceItemsRes = await getBuyerInvoiceItems({buyerInvoiceItemIds: buyerInvoiceItemIds, paginator: false, joinRequired: true})

            if (buyerInvoiceItemsRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: buyerInvoiceItemsRes.data.error, life: 3000 }))
            }
            let buyerInvoiceItems = buyerInvoiceItemsRes?.data
            console.log("buyerInvoiceItems", buyerInvoiceItems)
            let buyerReqItemsIds = buyerInvoiceItems?.map(eachInvoice => eachInvoice?.buyerReqItemId).filter(eachBuyerReqItemId => eachBuyerReqItemId)
            let materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({buyerReqItemsIds: buyerReqItemsIds})
            console.log("materialDetailsRes", materialDetailsRes)
            if (materialDetailsRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: materialDetailsRes.data.error, life: 3000 }))
            }
            let materialDetails = materialDetailsRes?.data

            let pmBillAddrsIds = buyerInvoiceItems?.map(eachInvoice => eachInvoice["buyerInvoice.pmBillAddrId"])
            let relatedBillAddrsRes = await getCompanyBillAddrs({billAddrIds: pmBillAddrsIds, paginator: false})
            if (relatedBillAddrsRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: relatedBillAddrsRes.data.error, life: 3000 }))
            }
            let pmBillAddresses = relatedBillAddrsRes?.data?.data

            let creditNotesData = []

            for (let i = 0; i < adjustmentNoteItems.length; i++) {

                let counter = i + 1

                let CSGSTRate = 0
                let IGSTRate = 0
                let igstAmount = 0
                let sgstAmount = 0
                let cgstAmount = 0
                let IGSTLedger = ''
                let CGSTLedger = ''
                let SGSTLedger = ''
                let purchaseLedger = ''
                let buyerState = ''
                let procmartState = ''

                const relatedBuyerInvoiceItem = buyerInvoiceItems?.find(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceItemId === adjustmentNoteItems[i].buyerInvoiceItemId)
                console.log("relatedBuyerInvoiceItems", relatedBuyerInvoiceItem)
                const relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === relatedBuyerInvoiceItem?.materialId)
                let productName = relatedMaterial?.productName + `: ${relatedBuyerInvoiceItem?.HSNCode}`

                let itemAmountBeforeTax = round(parseFloat(adjustmentNoteItems[i]?.adjustedQty) * parseFloat(adjustmentNoteItems[i]?.adjustedPricePerUnit))
                let itemAmountWithTax = itemAmountBeforeTax

                if (relatedBuyerInvoiceItem?.["buyerInvoice.GSTType"] == "CS") {
                    CSGSTRate = relatedBuyerInvoiceItem?.GSTRate / 2
                    cgstAmount = itemAmountBeforeTax * CSGSTRate * 0.01
                    sgstAmount = itemAmountBeforeTax * CSGSTRate * 0.01
                    itemAmountWithTax += cgstAmount + sgstAmount
                }
                if (relatedBuyerInvoiceItem?.["buyerInvoice.GSTType"] == "I") {
                    igstAmount = itemAmountBeforeTax * relatedBuyerInvoiceItem?.GSTRate * 0.01
                    IGSTRate = relatedBuyerInvoiceItem?.GSTRate
                    itemAmountWithTax += igstAmount
                }
                console.log("itemAmountWithTax", itemAmountWithTax)
                if (relatedBuyerInvoiceItem?.GSTRate && relatedBuyerInvoiceItem?.["buyerInvoice.GSTType"] === "I") {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === relatedBuyerInvoiceItem?.["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    IGSTLedger = relatedStateCode + " " + "IGST On Output @" + " " + relatedBuyerInvoiceItem?.GSTRate + "%"
                }
                else {
                    IGSTLedger = ''
                }

                if (relatedBuyerInvoiceItem?.GSTRate && relatedBuyerInvoiceItem?.["buyerInvoice.GSTType"] === "CS") {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === relatedBuyerInvoiceItem?.["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    SGSTLedger = relatedStateCode + " " + "SGST On Output @" + " " + relatedBuyerInvoiceItem?.GSTRate / 2 + "%"
                }
                else {
                    SGSTLedger = ''
                }

                if (relatedBuyerInvoiceItem?.GSTRate && relatedBuyerInvoiceItem?.["buyerInvoice.GSTType"] === "CS") {
                    const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === relatedBuyerInvoiceItem?.["buyerInvoice.pmBillAddrId"])
                    let relatedPMState = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                    let relatedStateCode = relatedPMState?.stateName?.toUpperCase() === "TAMIL NADU" ? 'TN' : relatedPMState?.stateName.slice(0, 1)
                    CGSTLedger = relatedStateCode + " " + "CGST On Output @" + " " + relatedBuyerInvoiceItem?.GSTRate / 2 + "%"
                }
                else {
                    CGSTLedger = ''
                }

                if (relatedBuyerInvoiceItem?.GSTRate && relatedBuyerInvoiceItem?.["buyerInvoice.GSTType"] === "I") {
                    if (relatedBuyerInvoiceItem?.HSNCode?.toString().startsWith('99')) {
                        purchaseLedger = "IGST Sales @" + " " + (relatedBuyerInvoiceItem?.GSTRate ? relatedBuyerInvoiceItem?.GSTRate : 0)+ "%" 
                        if(relatedBuyerInvoiceItem.GSTRate){
                            purchaseLedger += "_Services"
                        }
                    }
                    else {
                        purchaseLedger = "IGST Sales @" + " " + (relatedBuyerInvoiceItem?.GSTRate ? relatedBuyerInvoiceItem?.GSTRate : 0) + "%"
                        if(relatedBuyerInvoiceItem?.GSTRate){
                            purchaseLedger += "_Goods"
                        }
                    }
                }
                else {
                    if (relatedBuyerInvoiceItem?.HSNCode.toString().startsWith('99')) {
                        purchaseLedger = "Basic Sales @" + " " + (relatedBuyerInvoiceItem?.GSTRate ? relatedBuyerInvoiceItem?.GSTRate : 0) + "%" 
                        if(relatedBuyerInvoiceItem.GSTRate){
                            purchaseLedger += "_Services"
                        }
                    }
                    else {
                        purchaseLedger = "Basic Sales @" + " " + (relatedBuyerInvoiceItem?.GSTRate ? relatedBuyerInvoiceItem?.GSTRate : 0) + "%"
                        if(relatedBuyerInvoiceItem?.GSTRate){
                            purchaseLedger += "_Goods"
                        }
                    }
                }

                const date = moment(adjustmentNoteItems[i]["adjustmentNotes.createdAt"]).format(DATE_FORMAT)
                const buyerPONumbers = relatedBuyerInvoiceItem?.["buyerInvoice.buyerPONumbers"]?.length ?  relatedBuyerInvoiceItem?.["buyerInvoice.buyerPONumbers"]?.join(",") : ""

                const relatedPMBillAddress = pmBillAddresses?.find(eachBillAddr => eachBillAddr?.billAddrId === relatedBuyerInvoiceItem?.["buyerInvoice.pmBillAddrId"])
                let relatedProcmartStateAddress = states?.find(eachState => eachState?.stateId === parseInt(relatedPMBillAddress?.gstinCode.slice(0, 2)))
                let relatedBuyerStateAddress = states?.find(eachState => eachState?.stateId === parseInt(relatedBuyerInvoiceItem?.["buyerInvoice.billingAddress.gstinCode"].toString().slice(0, 2)))
                buyerState = relatedBuyerStateAddress?.stateName
                procmartState = relatedProcmartStateAddress?.stateName

                if(procmartState){
                    if(procmartState?.toUpperCase() === "MAHARASHTRA"){
                        procmartState = "Pune"
                    } else if(procmartState?.toUpperCase() === "TAMIL NADU"){
                        procmartState = "Chennai"
                    }
                }

                let isCancelled = adjustmentNoteItems[i]["adjustmentNotes.statusId"] === 6 ? true : false
                let docNo = isCancelled ? `Cancelled - ${adjustmentNoteItems[i].docNo}` : adjustmentNoteItems[i].docNo

                const downloadObj = {

                    'Sr. No.': counter,
                    'UNIQUE ID': docNo,
                    'BASE-VCH-TYPE': 'Sales Inward',
                    'VCH-TYPE': 'Sales Inward',
                    'VCH-NO': docNo,
                    'VCH-DATE': date,
                    'REF NO': relatedBuyerInvoiceItem?.["buyerInvoice.docNo"] ? relatedBuyerInvoiceItem?.["buyerInvoice.docNo"] : "",
                    'REF-DATE': relatedBuyerInvoiceItem?.["buyerInvoice.createdAt"] ? moment(relatedBuyerInvoiceItem["buyerInvoice.createdAt"]).format(DATE_FORMAT) : "",
                    'PARTY': relatedBuyerInvoiceItem?.["buyerInvoice.billingAddress.ledgerName"] ? relatedBuyerInvoiceItem?.["buyerInvoice.billingAddress.ledgerName"] : relatedBuyerInvoiceItem?.["buyerInvoice.company.companyName"],
                    'GSTIN': relatedBuyerInvoiceItem?.["buyerInvoice.billingAddress.gstinCode"],
                    'State': buyerState,
                    'Term Of Delivery': 'COD',
                    'Product Name': productName,
                    'HSN': relatedBuyerInvoiceItem?.HSNCode,
                    'Client ERP Code': relatedMaterial?.companyERPCode,
                    'Unit': relatedMaterial?.UOM,
                    'Quantity': adjustmentNoteItems[i]?.adjustedQty,
                    'Rate':adjustmentNoteItems[i]?.adjustedPricePerUnit,
                    'Buyer Basic Price': itemAmountBeforeTax,
                    'Other Charges Ledger': '',
                    'Other Charges Amount': '',
                    'Trade Discount': '',
                    'IGST Ledger': IGSTLedger,
                    'IGST %': IGSTRate,
                    'IGST Amount': igstAmount,
                    'CGST Ledger': CGSTLedger,
                    'CGST %': CSGSTRate,
                    'CGST Amount': cgstAmount,
                    'SGST Ledger': SGSTLedger,
                    'SGST %': CSGSTRate,
                    'SGST Amount': sgstAmount,
                    'Buyer Total Price': itemAmountWithTax,
                    'Purchase Ledger': purchaseLedger,
                    'Narration': buyerPONumbers,
                    'Auto Round Off': 'Yes',
                    'Cost Center': procmartState,
                    // 'Buyer Total Price': itemAmountWithTax
                }

                creditNotesData.push(downloadObj)
            }


            if (dataFormat === "CSV") {
                let csv = Papa.unparse(creditNotesData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "creditNotes.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(creditNotesData)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'creditNotes.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const downloadProductsData = async (dataFormat) => {
        setIsLoading(true)

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }

        const response = await getBuyerInvoiceItems({ ...updatedSearchParams, paginator: false, joinRequired: true })
        
        // console.log("productsData", response)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            let invoices = response.data

            let buyerReqItemsIds = invoices?.map(eachInvoice => eachInvoice?.buyerReqItemId).filter(eachBuyerReqItemId => eachBuyerReqItemId)

            const buyerInvoiceIds = response.data?.map(eachBuyerInvoiceItem => eachBuyerInvoiceItem.buyerInvoiceId)
            const docReplacementItems = await getDocItemReplacementLogAndMapByDocIds({docIds: buyerInvoiceIds})

            invoices = generateReplacedProducts(response.data, docReplacementItems.data)

            let materialDetailsRes = await getMaterialItemsDataByBuyerReqItemIds({buyerReqItemsIds: buyerReqItemsIds})
            if (materialDetailsRes.failure) {
                return dispatch(raiseToast({ severity: 'error', detail: materialDetailsRes.data.error, life: 3000 }))
            }
            let materialDetails = materialDetailsRes?.data
            // console.log("materia", materialDetails)
            const productsData = []

            let totalBasicPrice = 0
            let totalAmount = 0
            let totalCGST = 0
            let totalSGST = 0
            let totalIGST = 0

            for (let i = 0; i < invoices.length; i++) {

                let counter = i + 1

                let userName = getFullName(invoices[i]["buyerInvoice.user.firstName"], invoices[i]["buyerInvoice.user.lastName"])

                let basicPrice = invoices[i].itemAmountWithTax - invoices[i].itemAmountBeforeTax

                let cgstAmount = 0
                let sgstAmount = 0
                let CSGSTRate = 0

                if (invoices[i]["buyerInvoice.GSTType"] == "CS") {
                    cgstAmount = basicPrice / 2
                    sgstAmount = basicPrice / 2
                    CSGSTRate = invoices[i].GSTRate / 2
                }

                let igstAmount = 0
                let IGSTRate = 0
                if (invoices[i]["buyerInvoice.GSTType"] == "I") {
                    igstAmount = basicPrice
                    IGSTRate = invoices[i].GSTRate
                }

                totalBasicPrice = parseFloat(parseFloat(invoices[i]?.itemAmountBeforeTax) + parseFloat(totalBasicPrice)).toFixed(2)

                totalCGST = parseFloat(parseFloat(cgstAmount) + parseFloat(totalCGST)).toFixed(2)

                totalSGST = parseFloat(parseFloat(sgstAmount) + parseFloat(totalSGST)).toFixed(2)

                totalIGST = parseFloat(parseFloat(igstAmount) + parseFloat(totalIGST)).toFixed(2)

                totalAmount = parseFloat(parseFloat(invoices[i].totalInvAmount) + parseFloat(totalAmount)).toFixed(2)

                const buyerPONumbers = invoices[i]["buyerInvoice.buyerPONumbers"]?.length ?  invoices[i]["buyerInvoice.buyerPONumbers"]?.join(",") : ""

                let relatedMaterial = materialDetails?.find(eachMaterial => eachMaterial?.materialId === invoices[i]?.materialId)

                let relatedCompanySupplyType = companySupplyTypes.find(eachSupplyType => eachSupplyType.supplyTypeId === invoices[i]["buyerInvoice.supplyTypeId"])

                let relatedCompanyBranch = companyBranches.find(eachBranch => eachBranch.branchId === invoices[i]["buyerInvoice.pmBranchId"])

                let isCancelled = invoices[i]["buyerInvoice.statusId"] === 6 ? true : false
                let docNo = isCancelled ? `Cancelled - ${invoices[i]["buyerInvoice.docNo"]}` : invoices[i]["buyerInvoice.docNo"]
                
                const downloadObj = {
                    'Sr. No.': counter,
                    'Invoice Date':  moment(invoices[i]["buyerInvoice.createdAt"]).format(DATE_FORMAT),
                    'Invoice Number':  docNo, //invoices[i]["buyerInvoice.docNo"]
                    'Buyer PO No': buyerPONumbers,
                    'Buyer PO Date': moment(invoices[i].buyerPOCreatedAt).format(DATE_FORMAT),
                    //'Buyer PO Received Date' : '',
                    'Buyer Name': userName,
                    'Company Name': invoices[i]['buyerInvoice.company.companyName'],
                    'Buyer City': relatedCompanyBranch?.branchName ? relatedCompanyBranch?.branchName : '',
                    'GSTIN': invoices[i]['buyerInvoice.billingAddress.gstinCode'],
                    'Products': invoices[i].productName ? invoices[i].productName : relatedMaterial?.productName,
                    'HSN': invoices[i].HSNCode,
                    'Specifications': invoices[i].productSpecification ? invoices[i].productSpecification : relatedMaterial?.productSpecification,
                    // 'Industry': invoices[i].category,
                    'Company ERP Code': relatedMaterial?.companyERPCode,
                    'Quantity': invoices[i]?.qty,
                    'Unit': invoices[i].UOM ? invoices[i].UOM : relatedMaterial?.UOM,
                    'Unit Price':invoices[i]?.unitPrice,
                    'Buyer Basic Price': invoices[i]?.itemAmountBeforeTax,
                    'Buyer CGST (%)': CSGSTRate,
                    'Buyer CGST Amount': parseFloat(cgstAmount).toFixed(2),
                    'Buyer SGST (%)': CSGSTRate,
                    'Buyer SGST Amount': parseFloat(sgstAmount).toFixed(2),
                    'Buyer IGST (%)': IGSTRate,
                    'Buyer IGST Amount': parseFloat(igstAmount).toFixed(2),
                    'Buyer Total Price': parseFloat(invoices[i].itemAmountWithTax).toFixed(2),
                    'Logistics Charge': invoices[i].logisticsBeforeTax,
                    //'Type': invoices[i].orderType,
                    'Supply Type': relatedCompanySupplyType?.supplyType ? relatedCompanySupplyType?.supplyType : "",
                    'Cancelled': invoices[i]["buyerInvoice.statusId"] === 6 ? 'Yes' : 'No'
                }

                productsData.push(downloadObj)
            }

            productsData.push({
                Unitprice: 'TOTAL : ',
                'Buyer Basic Price': parseFloat(totalBasicPrice).toFixed(2),
                'Buyer CGST Amount': parseFloat(totalCGST).toFixed(2),
                'Buyer SGST Amount': parseFloat(totalSGST).toFixed(2),
                'Buyer IGST Amount': parseFloat(totalIGST).toFixed(2),
                'Buyer Total Price': parseFloat(totalAmount).toFixed(2),
            })

            // productsData.push({
            //     'CGST Amount': parseFloat(totalCGST).toFixed(2),
            //     'SGST Amount': parseFloat(totalSGST).toFixed(2),
            //     'IGST Amount': parseFloat(totalIGST).toFixed(2),
            //     'Total Price': parseFloat(totalAmount).toFixed(2),
            // })

            if (dataFormat === "CSV") {
                let csv = Papa.unparse(productsData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "products.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(productsData)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'products.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const downloadAccountsData = async (dataFormat) => {
        setIsLoading(true)

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }
        const response = await searchBuyerInvoice({ ...updatedSearchParams, paginator: false, statusIds: [1, 6] })
        // console.log("response", response)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            const invoices = response.data.data
            console.log("incoides", invoices)
            const acconutsData = []

            let totalAmount = 0
            let totalCGST = 0
            let totalSGST = 0
            let totalIGST = 0

            for (let i = 0; i < invoices.length; i++) {

                let userName = invoices[i]["user.firstName"]
                if (invoices[i]["user.lastName"]) {
                    userName = userName + " " + invoices[i]["user.lastName"]
                }

                let basicPrice = invoices[i].totalAmountBeforeTax - invoices[i].logisticsBeforeTax

                let cgstAmount = 0
                let sgstAmount = 0
                if (invoices[i].GSTType == "CS") {
                    cgstAmount = invoices[i].totalInvTax / 2
                    sgstAmount = invoices[i].totalInvTax / 2
                }

                let igstAmount = 0
                if (invoices[i].GSTType == "I") {
                    igstAmount = invoices[i].totalInvTax
                }


                totalCGST = parseFloat(parseFloat(cgstAmount) + parseFloat(totalCGST)).toFixed(2)

                totalSGST = parseFloat(parseFloat(sgstAmount) + parseFloat(totalSGST)).toFixed(2)

                totalIGST = parseFloat(parseFloat(igstAmount) + parseFloat(totalIGST)).toFixed(2)

                totalAmount = parseFloat(parseFloat(invoices[i].totalInvAmount) + parseFloat(totalAmount)).toFixed(2)
                const buyerPONumbers = invoices[i]["buyerPONumbers"]?.length ?  invoices[i]["buyerPONumbers"]?.join(",") : ""
                let buyerPODate =  invoices[i]["buyerPODate"] ? moment(invoices[i]["buyerPODate"]).format(DATE_FORMAT) : '-'
                
                let relatedCompanyBranch = companyBranches?.find(eachCompanyBranch => eachCompanyBranch?.branchId === invoices[i]["pmBranchId"])

                let isCancelled = invoices[i]?.statusId === 6 ? true : false
                let docNo = isCancelled ? `Cancelled - ${invoices[i]?.docNo}` : invoices[i]?.docNo

                const downloadObj = {

                    'Sr. No.': i + 1,
                    'Date': moment(invoices[i].createdAt).format(DATE_FORMAT),
                    'Company Name': invoices[i]['company.companyName'],
                    'City': relatedCompanyBranch?.branchName,
                    'GSTIN': invoices[i]['billingAddress.gstinCode'],
                    'User Name': userName,
                    'Invoice Number':  docNo,//invoices[i]?.docNo,
                    'PO No': buyerPONumbers,
                    'PO Date':  buyerPODate,
                    // 'PO Received Date' : '',
                    'Basic Price': basicPrice,
                    'Logistics Charge': invoices[i].logisticsBeforeTax,
                    'CGST Amount': parseFloat(cgstAmount).toFixed(2),
                    'SGST Amount': parseFloat(sgstAmount).toFixed(2),
                    'IGST Amount': parseFloat(igstAmount).toFixed(2),
                    'Total Price': parseFloat(invoices[i].totalInvAmount).toFixed(2),
                    'Type': invoices[i].orderType,
                }

                acconutsData.push(downloadObj)
            }

            acconutsData.push({
                'CGST Amount': parseFloat(totalCGST).toFixed(2),
                'SGST Amount': parseFloat(totalSGST).toFixed(2),
                'IGST Amount': parseFloat(totalIGST).toFixed(2),
                'Total Price': parseFloat(totalAmount).toFixed(2),
            })

            if (dataFormat === "CSV") {
                let csv = Papa.unparse(acconutsData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "accounts.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(acconutsData)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'accounts.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const downloadAddressData = async (dataFormat) => {
        setIsLoading(true)

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }
        const response = await searchBuyerInvoice({ ...updatedSearchParams, paginator: false })
        // console.log("response", response)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            const invoices = response.data.data

            const addressData = []

            let totalAmount = 0
            let totalCGST = 0
            let totalSGST = 0
            let totalIGST = 0

            for (let i = 0; i < invoices.length; i++) {

                let counter = i + 1

                let userName = invoices[i]["user.firstName"]
                if (invoices[i]["user.lastName"]) {
                    userName = userName + " " + invoices[i]["user.lastName"]
                }

                let basicPrice = invoices[i].totalAmountBeforeTax - invoices[i].logisticsBeforeTax

                let cgstAmount = 0
                let sgstAmount = 0
                if (invoices[i].GSTType == "CS") {
                    cgstAmount = invoices[i].totalInvTax / 2
                    sgstAmount = invoices[i].totalInvTax / 2
                }

                let igstAmount = 0
                if (invoices[i].GSTType == "I") {
                    igstAmount = invoices[i].totalInvTax
                }


                totalCGST = parseFloat(parseFloat(cgstAmount) + parseFloat(totalCGST)).toFixed(2)

                totalSGST = parseFloat(parseFloat(sgstAmount) + parseFloat(totalSGST)).toFixed(2)

                totalIGST = parseFloat(parseFloat(igstAmount) + parseFloat(totalIGST)).toFixed(2)

                totalAmount = parseFloat(parseFloat(invoices[i].totalInvAmount) + parseFloat(totalAmount)).toFixed(2)

                const downloadObj = {

                    'Sr. No.': counter,
                    'Date': moment(invoices[i].createdAt).format(DATE_FORMAT),
                    'Company Name': invoices[i]['company.companyName'],
                    'GSTIN': invoices[i]['billingAddress.gstinCode'],
                    'User Name': userName,
                    'Invoice Number': invoices[i].docNo,
                    'PO No': invoices[i]['buyerInvoiceItems.buyerPOId'],
                    // 'City': '',
                    // 'PO Date': '',
                    // 'PO Received Date' : '',
                    'Basic Price': basicPrice,
                    'Logistics Charge': invoices[i].logisticsBeforeTax,
                    'CGST Amount': parseFloat(cgstAmount).toFixed(2),
                    'SGST Amount': parseFloat(sgstAmount).toFixed(2),
                    'IGST Amount': parseFloat(igstAmount).toFixed(2),
                    'Total Price': parseFloat(invoices[i].totalInvAmount).toFixed(2),
                    'Billing Address': invoices[i]['billingAddress.billAddress'],
                    'Shipping Address': '',
                    'Type': invoices[i].orderType,
                }

                addressData.push(downloadObj)
            }

            addressData.push({
                'CGST Amount': parseFloat(totalCGST).toFixed(2),
                'SGST Amount': parseFloat(totalSGST).toFixed(2),
                'IGST Amount': parseFloat(totalIGST).toFixed(2),
                'Total Price': parseFloat(totalAmount).toFixed(2),
            })


            if (dataFormat === "CSV") {
                let csv = Papa.unparse(addressData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "address.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(addressData)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'address.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const downloadData = async (dataFormat) => {
        setIsLoading(true)

        const updatedSearchParams = { ...searchParams }
        if(updatedSearchParams.searchBy !== "all"){
            updatedSearchParams[updatedSearchParams.searchBy] = updatedSearchParams.searchText.trim()
        }
        const response = await searchBuyerInvoice({ ...updatedSearchParams, paginator: false, statusIds: [1, 6] })
        // console.log("response", response)
        setIsLoading(false)

        if (response.failure) {
            return dispatch(raiseToast({ severity: 'error', detail: response.data.error, life: 3000 }))
        } else {
            const responseData = response.data.data
            const buyerInvoices = responseData
            console.log("buyerInvoice", buyerInvoices)
            let buyerInvoiceData = []

            let totalAmount = 0
            let totalCGST = 0
            let totalSGST = 0
            let totalIGST = 0

            for (let i = 0; i < buyerInvoices.length; i++) {

                let counter = i + 1

                let userName = getFullName(buyerInvoices[i]["user.firstName"], buyerInvoices[i]["user.lastName"])
                let kamName = getFullName(buyerInvoices[i]["kamUser.firstName"], buyerInvoices[i]["kamUser.lastName"])

                let basicPrice = buyerInvoices[i].totalAmountBeforeTax
                let totalInvTax = buyerInvoices[i].totalInvTax

                let cgstAmount = 0
                let sgstAmount = 0
                let CSGSTRate = 0

                if (buyerInvoices[i]?.GSTType == "CS") {
                    cgstAmount = totalInvTax / 2
                    sgstAmount = totalInvTax / 2
                    CSGSTRate = buyerInvoices[i].GSTRate / 2
                }

                let igstAmount = 0
                let IGSTRate = 0
                if (buyerInvoices[i]?.GSTType == "I") {
                    igstAmount = totalInvTax
                    IGSTRate = buyerInvoices[i].GSTRate
                }


                totalCGST = parseFloat(parseFloat(cgstAmount) + parseFloat(totalCGST)).toFixed(2)

                totalSGST = parseFloat(parseFloat(sgstAmount) + parseFloat(totalSGST)).toFixed(2)

                totalIGST = parseFloat(parseFloat(igstAmount) + parseFloat(totalIGST)).toFixed(2)

                totalAmount = parseFloat(parseFloat(buyerInvoices[i].totalInvAmount) + parseFloat(totalAmount)).toFixed(2)

                const buyerPONumbers = buyerInvoices[i]?.buyerPONumbers?.length ?  buyerInvoices[i]?.buyerPONumbers?.join(",") : ""
                let isCancelled = buyerInvoices[i]?.statusId === 6 ? true : false
                let docNo = isCancelled ? `Cancelled - ${buyerInvoices[i]?.docNo}` : buyerInvoices[i]?.docNo
                
                const downloadObj = {
                    'Sr. No.': counter,
                    'Invoice Date': moment(buyerInvoices[i].createdAt).format(DATE_FORMAT),
                    'Invoice Number': docNo, //buyerInvoices[i].docNo,
                    'Buyer PO No': buyerPONumbers,
                    'Buyer PO Date': moment(buyerInvoices[i].buyerPODate).format(DATE_FORMAT),
                    'Kam Name': kamName,
                    'Buyer Name': userName,
                    'Company Name': buyerInvoices[i]['company.companyName'],
                    'GSTIN': buyerInvoices[i]['billingAddress.gstinCode'],
                    'Buyer Basic Price': buyerInvoices[i]?.totalAmountBeforeTax,
                    'Logistics Charge': buyerInvoices[i].logisticsBeforeTax,
                    'Buyer CGST': parseFloat(cgstAmount).toFixed(2),
                    // 'Buyer CGST Rate': `${CSGSTRate}%`,
                    'Buyer SGST': parseFloat(sgstAmount).toFixed(2),
                    // 'Buyer SGST Rate': `${CSGSTRate}%`,
                    'Buyer IGST': parseFloat(igstAmount).toFixed(2),
                    // 'Buyer IGST Rate': `${IGSTRate}%`,
                    'Buyer Total Price': parseFloat(buyerInvoices[i].totalAmountWithTax).toFixed(2),
                    'GRN Done': buyerInvoices[i]["clientGRN"] ? "Yes" : "No",
                    'Payment Date': buyerInvoices[i]["paymentDate"] ? getDateString(buyerInvoices[i]["paymentDate"]) : ""
                }

                buyerInvoiceData.push(downloadObj)
            }


            if (dataFormat === "CSV") {
                let csv = Papa.unparse(buyerInvoiceData, { download: true })
                let blob = new Blob([csv])
                let a = window.document.createElement("a")
                a.href = window.URL.createObjectURL(blob, { type: "text/plain" })
                a.download = "buyerInvoice.csv"
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
            }
            if (dataFormat === "XLSX") {
                const ws = utils.json_to_sheet(buyerInvoiceData)
                const wb = utils.book_new()
                utils.book_append_sheet(wb, ws, 'Sheet1')
                const blob = new Blob([write(wb, { bookType: 'xlsx', type: 'array' })])
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = 'buyerInvoice.xlsx'
                a.click()
                URL.revokeObjectURL(url)
            }
        }
    }

    const handleSearchKeyPress = (event) => {
        if (event.key === 'Enter') {
            handleSearch()
        }
    }

    return (
        <div className="p-card filter-container p-2" style={{border:"1px solid #e9ecef"}} onKeyDown={handleSearchKeyPress}>
            <div className=""> 
                {
                    searchOptions.map(eachOption => {
                        if (eachOption.type === "SEARCH_TEXT") {

                            let searchByOptions = [{label: 'No Filters', value: 'all'}]
                            searchConfig.map(eachSearchBy => {
                                if (eachSearchBy.isSearchByOption) {
                                    const optionInUse = searchOptions.find(eachSearchOption => eachSearchOption.srNO === eachSearchBy.srNO)
                                    if(!optionInUse){
                                        searchByOptions.push({ label: eachSearchBy.label, value: eachSearchBy.name })
                                    }
                                }
                            })
    
                            return (
                                <div className=''>
                                    <div className="flex flex-column col-12 pb-0 pt-0">
                                        {['kamName'].includes(searchParams.searchBy) ? (
                                            <AutoCompleteField
                                                value={searchParams.searchText}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(searchParams.searchBy, e.query)}
                                                field="displayName"
                                                labelText="Search Text"
                                                onChange={handleSearchOnChange}
                                                name="searchText"
                                                dropdown
                                                refName={searchTextRef}
                                            />
                                        ) : (
                                            <TextInputField
                                                name="searchText"
                                                labelText="Search Text"
                                                placeholder="No Filter"
                                                refName={searchTextRef}
                                                value={searchParams["searchText"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        )}
                                    </div>
                                    {searchParams.searchText && (
                                        <div className="flex flex-column col-12 pb-0">
                                            <DropDownField
                                                name="searchBy"
                                                labelText="Search By"
                                                options={searchByOptions}
                                                value={searchParams["searchBy"]}
                                                onChange={handleSearchOnChange}
                                            />
                                        </div>
                                    )}
                                </div>
                            )
                        }

                        if(eachOption.type === "DATE"){
                            return (
                                <>
                                    <DateFilter 
                                        eachOption={eachOption} 
                                        searchParams={searchParams} 
                                        dateOptions={["MTD", "PM", "L15", "L30"]}
                                        handleDateRangeChange={handleDateRangeChange} 
                                        handleSearchOnChange={handleSearchOnChange}
                                        removeFilterOption={removeFilterOption}
                                    />
                                </>
                            )
                        }

                        if(eachOption.type === "SELECT"){
                            return (
                                <div className=''>
                                    { !eachOption.static ? 
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={()=> removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                        :
                                        null 
                                    }
                                    <div className="flex flex-column col-12" >
                                        <DropDownField name={eachOption.name} options={eachOption.options} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                    </div>
                                </div>
                            )
                        }

                        if (eachOption.type === "TEXT") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12 pb-0">
                                            <TextInputField name={eachOption.name} labelText={eachOption.label} value={searchParams[eachOption.name]} onChange={handleSearchOnChange} />
                                        </div>
                                    }
                                </>
                            )
                        }
    
                        if (eachOption.type === "AUTO_COMPLETE") {
                            return (
                                <>
                                    {!eachOption.static &&
                                        <div className="flex justify-content-end p-0 col-12 remove-opt">
                                            <i className="pi pi-minus-circle remove-opt-icon" onClick={() => removeFilterOption(eachOption.srNO)} ></i>
                                        </div>
                                    }
                                    {
                                        <div className="flex flex-column col-12 pb-0">
                                            <AutoCompleteField
                                                value={searchParams[eachOption.name]}
                                                suggestions={suggestions}
                                                searchMethod={(e) => autoCompleteSearch(eachOption.name, e.query)}
                                                field="displayName"
                                                labelText={eachOption.label}
                                                onChange={handleSearchOnChange}
                                                name={eachOption.name}
                                                dropdown
                                                style={{ boxShadow:"0 0.7px 1px 1px #ddd"}}
                                            />
                                        </div>
                                    }
                                </>
                            )
                        }
                    })
                }
                {addFilterOptions.length > 0 && (
                <div className="flex col-12 justify-content-end pt-0 mt-2">
                    <Menu model={addFilterOptions} popup ref={filterMenu} />
                    <Button icon="pi pi-filter" className="h-2rem p-2 action-btn hover:surface-300 hover:text-700" label="Add Filter" onClick={(e) => filterMenu.current.toggle(e)} />
                </div>
                )}

                <div className="flex flex-column col-12 mb-0 pb-0">
                    <div className="grid">
                        <div className="flex col-12 mb-0 gap-1 pb-0" style={{cursor: isPageLoading ? 'not-allowed' : 'pointer'}}>
                            <Button label="Search" style={{flexGrow: 1}} className="py-2" onClick={handleSearch} disabled={isPageLoading}/>
                            <Menu model={downloadFormatOptions} popup ref={downloadMenu} />
                            <Button icon="pi pi-download" className="py-2 px-3"  onClick={(e) => downloadMenu.current.toggle(e)} permissions={[50]} disabled={!searchParams?.fromDate || !searchParams?.toDate}/>
                        </div>
                    </div>
                </div>
            </div>
            <Loading visible={isLoading} />
        </div>

    )
}

export default Search